/**
 * Georgetown Collection Cards - Details Toggle
 * Handles expanding/collapsing collection card details
 */

class CollectionCardDetails extends HTMLElement {
  constructor() {
    super();
    this.detailsBtn = this.querySelector('.collection-details-btn');
    this.card = this.closest('.collection-card');
    this.isExpanded = false;
    
    if (this.detailsBtn) {
      this.detailsBtn.addEventListener('click', this.toggleDetails.bind(this));
    }
  }

  toggleDetails(e) {
    e.preventDefault();
    e.stopPropagation();
    
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.card?.classList.add('collection-card--expanded');
      this.detailsBtn.textContent = 'close';
    } else {
      this.card?.classList.remove('collection-card--expanded');
      this.detailsBtn.textContent = 'details';
    }
  }
}

customElements.define('collection-card-details', CollectionCardDetails);
